<template>
  <div>
    <div
      @click="handleClick"
      :class="isActive ? 'activeBorder' : 'hoverBorder'"
      :style="{ paddingLeft: (level * 20 + 40) + 'px' }"
      :title="item.label"
      style="text-align:left;width:100%;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;margin-top:3px;display:flex;align-items:center;justify-content:space-between;"
    >
      <p style="overflow:hidden;text-overflow:ellipsis;flex:1;">{{ item.label || item.text }}</p>
      <template v-if="hasChildren">
        <span style="margin-right:40px;flex-shrink:0;display:inline-flex;align-items:center;">
          <i :class="expanded ? 'el-icon-arrow-down' : 'el-icon-arrow-right'" style="color:#999;font-size:16px;"></i>
        </span>
      </template>
      <template v-else>
        <img :src="isActive ? require('@/assets/list/active.png') : require('@/assets/list/actived.png')"
             alt="" style="width:13px;height:12px;margin-right:40px;flex-shrink:0;">
      </template>
    </div>
    <el-divider v-if="!showChildren"></el-divider>
    <div v-if="showChildren">
      <sidebar-menu-item
        v-for="child in item.children"
        :key="child.id"
        :item="child"
        :level="level + 1"
        :active-id="activeId"
        @select="handleChildSelect"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'SidebarMenuItem',
  props: {
    item: {
      type: Object,
      required: true
    },
    level: {
      type: Number,
      default: 0
    },
    activeId: {
      type: [String, Number],
      default: ''
    }
  },
  data() {
    return {
      expanded: false
    }
  },
  computed: {
    hasChildren() {
      return this.item.children && this.item.children.length > 0
    },
    isActive() {
      return String(this.item.id) === String(this.activeId)
    },
    showChildren() {
      return this.hasChildren && this.expanded
    }
  },
  methods: {
    handleClick() {
      if (this.hasChildren) {
        this.expanded = !this.expanded
      }
      this.$emit('select', this.item)
    },
    handleChildSelect(item) {
      this.$emit('select', item)
    },
    deepFind(children, id) {
      for (const c of children) {
        if (String(c.id) === String(id)) return true
        if (c.children && this.deepFind(c.children, id)) return true
      }
      return false
    }
  },
  watch: {
    activeId: {
      immediate: true,
      handler(val) {
        if (!this.hasChildren || !val) return
        // 展开条件：active 就是本项，或者是本项的后代
        const match = String(this.item.id) === String(val) ||
          (this.item.children || []).some(c =>
            String(c.id) === String(val) ||
            (c.children && this.deepFind(c.children, val))
          )
        if (match) {
          this.expanded = true
        }
      }
    }
  }
}
</script>

<style scoped>
.activeBorder{
  font-size:20px;
  font-weight:700;
  cursor: pointer;
  border-left: 4px solid #176DAA;
  color: #176DAA;
}
.hoverBorder{
  font-size:20px;
  font-weight:400;
  color:#333333;
  cursor: pointer;
}
.hoverBorder:hover{
  border-left: 4px solid #176DAA;
  color: #176DAA;
  font-weight: 700;
}
</style>
